import React, { useCallback, useState, useRef, useEffect } from 'react'

import { Report } from '~/components';
import {
    RadioGroup
} from '~/components/Form';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';
import { toast } from 'react-toastify';

import { TypeFilters } from '~/components';
import { Select } from '~/components/Form'


export default function DlgRelMedicao() {

    const [open, setOpen] = useState(true);
    const reference = useRef(null);
    const filterRef = useRef(null);
    const [post, setPost] = useState('')
    const [tanque, setTanque] = useState('')
    const [clearTanque, setClearTanque] = useState(false)
    const [dataObjto, setDataObjto] = useState({});


    const [tipoTypeFilters, setTipoTypeFilters] = useState(0)


    const [dataHoraInicial, setDataHoraInicial] = useState(format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
    ))
    const [dataHoraFinal, setDataHoraFinal] = useState(format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
    ))

    const handleGetData = useCallback((value) => {
        setTipoTypeFilters(value.tipo)
        if (value.tipo === 1) {
            setDataHoraInicial(value.datahora_inicio)
            setDataHoraFinal(value.datahora_fim)
        } else if (value.tipo == 5) {

            setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
            setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

        } else if (value.tipo == 2) {
            setDataHoraInicial(value.data_inicio + ' 00:00:00')
            setDataHoraFinal(value.data_fim + ' 23:59:59')
        }
        setDataObjto(value);
    }, [filterRef]);


    const schemaDataHora = Yup.object().shape({
        datahora_inicio: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        datahora_fim: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyData = Yup.object().shape({
        data_inicio: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyDataTurno = Yup.object().shape({
        data_inicio_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),

    });

    const schemaPostoTanque = Yup.object().shape({
        posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio')),
        tanque: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio')),
    });




    const handleValidate = useCallback(async (data) => {
        try {

            if (tipoTypeFilters == 0 || tipoTypeFilters == undefined) {
                toast.error('selecione uma opção de data !')
                const defaultSchema = Yup.object().shape({
                    tipo: Yup.number().required('Selecione uma opção de data').min(1, 'Selecione uma opção de data')
                })
                await defaultSchema.validate({ tipo: tipoTypeFilters }, {
                    abortEarly: false,
                });
                // throw Error('Selecione uma opção de data !')
            } else if (tipoTypeFilters == 1) {
                const testeObjct = { datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal, ...data }
                await schemaDataHora.concat(schemaPostoTanque).validate(testeObjct, {
                    abortEarly: false,
                })
            } else if (tipoTypeFilters == 5) {

                await schemaOnlyDataTurno.concat(schemaPostoTanque).validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, ...data }, {
                    abortEarly: false,
                });

            } else if (tipoTypeFilters == 2) {
                await schemaOnlyData.concat(schemaPostoTanque).validate({ data_inicio: dataHoraInicial, data_fim: dataHoraFinal, ...data }, {
                    abortEarly: false,
                });
            }
            filterRef.current.setErrors({})
        } catch (err) {
            const form = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    form[error.path] = error.message.replace(`${error.path} `, '');
                });
                filterRef.current.setErrors(form);
                throw err
            } else {
                throw err
            }
        }
    }, [tipoTypeFilters, dataHoraFinal, dataHoraInicial, filterRef, post])


    const handleSerializeForm = useCallback((param) => {

        return {
            ...param,
            posto: post.post_cod_posto ? post.post_cod_posto : '',
            posto_str: post.post_desc ? post.post_desc : '',
            datainicial: dataHoraInicial,
            datafinal: dataHoraFinal,
            idtarefapath: "dlgRelMedicao.swf"
        }

    }, [dataHoraInicial, dataHoraFinal, post, tipoTypeFilters])



    return (
        <>
            <Report
                ref={reference}
                open={open}
                onClose={() => setOpen(false)}
                title="RELATÓRIO DE MEDIÇÃO"
                relatorio="RELMEDICAO"
                validate={(param) =>
                    handleValidate(param)}
                serialize={(param) => handleSerializeForm(param)}
                initials={{ tipo: 'pdf' }}

            >

                <SelectComplete
                    name="posto"
                    title="Posto"
                    label="post_desc"
                    unique="post_cod_posto"
                    url="usuarioposto"
                    getValue={(value) => {
                        setClearTanque(true)
                        setPost(value)
                    }}
                />

                <TypeFilters
                    initials={{
                        tipo: 1,
                        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
                        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
                    }}
                    name="filtroData"
                    ref={filterRef}
                    numberOfYears={9}
                    options={[
                        { label: t('s.geral.filtro.turno'), value: 5 },
                        { label: t('s.geral.filtro.periododatahora'), value: 1 },
                        { label: t('s.geral.filtro.periododata'), value: 2 },
                    ]}
                    onCallback={handleGetData}
                    initialURL="/turno/getturnosinicio"
                    finalURL="/turno/getturnosfim"
                    code={post.post_cod_posto}
                />

                <Select
                    name="metatipo"
                    label="Tipo Medição"
                    options={
                        [{ label: 'Turno', value: 'A' },
                        { label: 'Avulso', value: 'M' },
                        { label: 'Sonda', value: 'S' },
                        { label: 'SondaDesc', value: 'D' },]
                    }
                    defaultValue="A"
                />

                <SelectComplete
                    name="tanque"
                    title="Tanque"
                    label="tafi_cod_tafi"
                    unique="tafi_cod_tafi"
                    getValue={(value) => {
                        setClearTanque(false)
                        setTanque(value)
                    }}
                    clearField={clearTanque}
                    disableClearable={!tanque.tafi_cod_tafi}
                    url={`tanquefisico/gettanquesfisico?codigoposto=${post.post_cod_posto}`}
                    onSerialize={(tanque) => tanque}
                />



                <RadioGroup
                    name="tipo"
                    label="Formato"
                    options={[
                        { label: 'PDF', value: 'pdf' },
                        { label: 'Excel', value: 'xls' },
                    ]}
                    defaultValue="pdf"
                    serialize={(value) => value}
                    row
                />

            </Report>
        </>

    )
}
